<template>
  <div class="tff">

    <div class="tff__header">

      <!-- TFF/TeamTip Logo -->
      <img src="../assets/tff/tff-teamtip.png" srcset="../assets/tff/tff-teamtip@2x.png 2x">

      <!-- Intro-Text -->
      <h1 data-testid="tff-title">{{ $t('create_betgame.welcome_to_teamtip') }}</h1>
      <p>{{ $t('create_betgame.welcome_to_teamtip_text_tff') }}</p>

      <!-- Flags -->
      <div class="tff__flags">
        <div class="tff__flags__item tff__flags__item--number">
          +20
        </div>
        <img class="tff__flags__item" src="../assets/tff/flag-it.svg">
        <img class="tff__flags__item" src="../assets/tff/flag-es.svg">
        <img class="tff__flags__item" src="../assets/tff/flag-en.svg">
        <img class="tff__flags__item" src="../assets/tff/flag-de.svg">
        <span>{{ $t('create_betgame.welcome_to_teamtip_paragraph_1') }}</span>
      </div>

    </div>

    <!-- User / Register -->
    <div class="tff__user">

      <!-- User -->
      <div class="tff__user__content">
        <img class="tff__user__avatar" src="../assets/tff/avatar.svg">
        <div class="tff__user__text">
          <div class="tff__user__text__label">
            {{ this.name }}
          </div>
          <div class="tff__user__text__sublabel">
            {{ this.email }}
          </div>
        </div>
      </div>

      <!-- CTA -->
      <router-link :to="{ name: 'register', params: { emailparam: this.email, nameparam: this.name }}" class="button" data-testid="tff-register">{{ $t('register.finish_registration') }}<img src="../assets/icons/ic_12_next_white.svg" class="button-icon--right"></router-link>
    </div>

    <!-- Feature Grid -->
    <div class="tff__features">

      <!-- Feature: App -->
      <div class="tff__features__item">
        <img src="../assets/tff/feature-01-app.svg">
        <div class="tff__features__item__text">
          <div class="tff__features__item__text__label">
            {{ $t('create_betgame.tff_feature_title_1') }}
          </div>
          <div class="tff__features__item__text__sublabel">
            {{ $t('create_betgame.tff_feature_text_1') }}
          </div>
        </div>
      </div>

      <!-- Feature: Tipprunden -->
      <div class="tff__features__item">
        <img src="../assets/tff/feature-02-tipprunde.svg">
        <div class="tff__features__item__text">
          <div class="tff__features__item__text__label">
            {{ $t('create_betgame.tff_feature_title_2') }}
          </div>
          <div class="tff__features__item__text__sublabel">
            {{ $t('create_betgame.tff_feature_text_2') }}
          </div>
        </div>
      </div>

      <!-- Feature: Battle -->
      <div class="tff__features__item">
        <img src="../assets/tff/feature-03-battle.svg">
        <div class="tff__features__item__text">
          <div class="tff__features__item__text__label">
            {{ $t('create_betgame.tff_feature_title_3') }}
          </div>
          <div class="tff__features__item__text__sublabel">
            {{ $t('create_betgame.tff_feature_text_3') }}
          </div>
        </div>
      </div>

      <!-- Feature: Lieblingsteam -->
      <div class="tff__features__item">
        <img src="../assets/tff/feature-04-team.svg">
        <div class="tff__features__item__text">
          <div class="tff__features__item__text__label">
            {{ $t('create_betgame.tff_feature_title_4') }}
          </div>
          <div class="tff__features__item__text__sublabel">
            {{ $t('create_betgame.tff_feature_text_4') }}
          </div>
        </div>
      </div>
    
    </div>

    <div class="tff__notification tff__notification--blue">

      <div class="tff__notification__content">

        <div class="tff__notification__text">
          <h2>{{ $t('create_betgame.tff_community_betgame_title') }}</h2>
          <p>{{ $t('create_betgame.tff_community_betgame_text') }}</p>
        </div>

        <router-link :to="joinCommunity" class="button" data-testid="tff-join-community">{{ $t('create_betgame.tff_cta_enter_community_betgame') }}</router-link>
        <router-link :to="startBetgame" class="button button-outline" data-testid="tff-create-betgame"><img src="../assets/icons/ic_12_plus_white.svg" class="button-icon--left">{{ $t('create_betgame.tff_cta_start_betgame') }}</router-link>

      </div>

    </div>

    <div class="tff__notification">

      <div class="tff__notification__content">

        <div class="tff__notification__text">
          <h2>{{ $t('create_betgame.tff_notification_title') }}</h2>
          <p>{{ $t('create_betgame.tff_notification_text') }}</p>
        </div>

        <!--<router-link to="/" class="button">E-Mail schreiben</router-link>
        <a href="mailto:kontakt@teamtip.net">E-Mail schreiben</a>-->
        <button v-on:click="writeEmailClicked" data-testid="tff-email">{{ $t('create_betgame.tff_write_email') }}</button>
        
      </div>

    </div>



    <!--<div class="input-container">
      <div class="input-header">
        Hallo {{ name }},
      </div>
      <div class="input-infotext">
        <p>herzlich Willkommen bei Teamtip! Da die „Tippspiel Für Freunde“ App nicht mehr weiterentwickelt wird, 
          freuen wir uns darauf dir hier bei Teamtip eine neue Tippspiel-Heimat anbieten zu können. Mit nur wenigen Klicks 
          kannst du hier deine Tipprunde anlegen und Freunde, Familie oder Kollegen dazu einladen. Wir bieten dir 
          für deine Tipprunden zahlreiche Wettbewerbe an und zudem unsere große offen Community-Tipprunde zur 
          Bundesligasaison 25/26 bei der es tolle Preise zu gewinnen gibt. 
          Wenn Du Fragen hast wende dich gerne an unser Support-Team: <a href="mailto:kontakt@teamtip.net">kontakt@teamtip.net</a>.</p>
        <p>Wir freuen uns auf dich und wünschen viel Spaß mit Teamtip!</p>
        <p style="margin-top: 20px;"></p>
        <button v-on:click="create">Eigene Tipprunde anlegen</button>
        <p style="margin-top: 20px;"></p>
        <button v-on:click="join">Zur Community-Tipprunde</button>
        <p style="margin-bottom: 20px;"></p>
      </div>
    </div>-->
    
    <!--
    <div class="p-4">
      <h1 class="text-xl font-bold mb-4">Willkommen bei Teamtip!</h1>
      <p class="mb-2">Hallo {{ name }},</p>
      <p class="mb-2">Deine E-Mail-Adresse ist: {{ email }}</p>
      <p class="mb-2">Deine Spracheinstellung ist: {{ lang }}</p>
      <p class="mb-2">Dein Login ist: {{ login }}</p>
      <p class="mb-4">Wir freuen uns, dass du dabei bist!</p>
    </div>
    -->
  </div>
</template>

<script>

import Numeral from 'numeral'
import moment from 'moment/moment'

export default {
  name: 'TFFWelcome',
  components: {
  },
  data() {
    return {
      name: '',
      email: '',
      lang: '',
      login: ''
    }
  },
  mounted() {
    window.localStorage.setItem('userSource', 'tff')
    this.$store.dispatch('setUserSource', 'tff')
    this.name = this.$route.query.name || ''
    this.email = this.$route.query.email || ''
    if(this.email.includes('@privaterelay.appleid.com')) {
      this.email = '' 
    }
    this.login = this.$route.query.login || ''
    if(this.$route.query.lang && this.$route.query.lang.length === 2) {
      this.lang = this.$route.query.lang
      if(this.lang !== 'de' && this.lang !== 'en') {
        this.lang = 'en'
      }
    } else {
      this.lang = 'de'
    }
    Numeral.locale(this.lang)
    moment.locale(this.lang)
    this.$i18n.locale = this.lang
  },
  computed: {
    joinCommunity() {
      return '/join/121543/86534236?username=' + this.name + '&useremail=' + this.email +
        '&lang=' + this.lang + '&login=' + this.login + '&src=tff'
    },
    startBetgame() {
      return { name: 'createbetgame', query: { name: this.name, email: this.email, 
          lang: this.lang, login: this.login, src: 'tff' } }
    }
  },
  methods: {
    writeEmailClicked() {
      window.open('mailto:kontakt@teamtip.net', '_self')
    },
    create() {
      this.$router.push({ name: 'createbetgame', query: { name: this.name, email: this.email, 
          lang: this.lang, login: this.login, src: 'tff' } })
      //this.$router.push({ name: 'createbetgame', query: { email: this.$route.query.email } })
      //this.$router.push('/createuserbetgame?type=1&competition=1')
    },
    join() {
      this.$router.push('/join/121543/86534236?username=' + this.name + '&useremail=' + this.email + 
        '&lang=' + this.lang + '&login=' + this.login + '&src=tff')
    }
  }
}

</script>

<style lang="scss" scoped>

  .tff {
    padding-top: 0 !important;
    padding-bottom: 0;
    max-width: 576px;
    margin: 0 auto;

    &__header {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: url('../assets/landingpage/header-background.jpg');
      background-size: cover;
      background-position: center center;
      margin: 0 -16px;
      padding: 48px 20px 104px;

      @media screen and (min-width: 608px) {
        margin: 0 calc((100vw - 576px) / -2);
        width: calc(100vw - 32px);
      }

      > img {
        margin-bottom: 27px;
      }

      h1, p {
        color: var(--color-on-primary);
        text-align: center;
        max-width: 576px;
        letter-spacing: -0.41px;
      }

      h1 {
        margin-bottom: 8px;
      }
    }

    &__flags {
      display: flex;
      justify-content: center;
      flex-direction: row-reverse;
      flex-wrap: wrap;
      margin-top: 34px;

      &__item {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        box-shadow: 0 0 0 2px var(--color-primary);
        background: var(--color-surface);
        object-fit: cover;
        margin-right: -4px;

        &--number {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 500;
          color: var(--color-text);
        }
      }

      span {
        font-size: 14px;
        width: 100%;
        text-align: center;
        color: rgba(var(--color-white-rgb), .48);
        margin-top: 12px;
      }
    }

    &__user {
      display: flex;
      flex-direction: column;
      background: var(--color-surface);
      border-radius: 8px;
      padding: 16px;
      box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
      margin-top: -70px;

      &__content {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
      }

      &__avatar {
        width: 40px;
        height: 40px;
        background: rgba(var(--color-text-rgb), .04);
        margin-right: 12px;
        border-radius: 50%;
      }

      &__text {
        display: flex;
        flex-direction: column;
        overflow: hidden;

        &__label {
          font-size: 17px;
          letter-spacing: -0.41px;
          font-weight: 500;
          color: var(--color-text);
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        &__sublabel {
          font-size: 14px;
          letter-spacing: -0.41px;
          color: var(--color-grey-mid);
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }

    &__features {
      display: grid;
      grid-column-gap: 24px;
      grid-row-gap: 36px;
      grid-template-columns: repeat(2,1fr);
      margin: 48px 0 64px;

      &__item {

        img {
          margin-bottom: 12px;
        }

        &__text {
          display: flex;
          flex-direction: column;
          overflow: hidden;

          &__label {
            font-size: 17px;
            letter-spacing: -0.41px;
            font-weight: 500;
            color: var(--color-text);
            margin-bottom: 8px;
          }

          &__sublabel {
            font-size: 14px;
            letter-spacing: -0.41px;
            color: rgba(var(--color-text-rgb), .48);
          }
        }

      }
    }

    &__notification {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      padding: 40px 16px 64px;
      background: var(--color-surface);
      margin: 0 -16px;

      @media screen and (min-width: 608px) {
        margin: 0 calc((100vw - 576px) / -2);
        width: calc(100vw - 32px);
      }

      &__content {
        max-width: 420px;
        margin: 0 auto;
      }

      h2 {
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 6px;
        letter-spacing: -0.41px;
      }

      p {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 34px;
        color: rgba(var(--color-text-rgb), .64);
      }

      .button {
        &:first-of-type {
          margin-bottom: 8px;
        }
      }

      &--blue {
        background: var(--color-primary);

        h2, p {
          color: var(--color-on-primary);
        }

        .button {

          &:first-of-type {
            background: var(--color-surface);
            color: var(--color-text);
          }

          color: var(--color-on-primary);
          box-shadow: inset 0 0 0 1.5px var(--color-on-primary);
        }
      }
    }
  }
</style>
